import './ExpirationPopupComponent.scss';
import LottieFileGenarationComponent
    from "../../../shared/components/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../constants";
import React from "react";

interface ExpirationPopupProps {

}

const ExpirationPopupComponent = (props: ExpirationPopupProps) => {
    return (

        <div className="modal__content">
            <div className={'confirm-popup-component width-300'}>
                <div className={'confirm-popup-image'}>
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.BlueConfirmationLottie}/>
                </div>
                <div className="confirm-popup-meta">
                    <div className={'confirm-popup-description expiration-popup-title font-weight-bold d-inline-block'}>
                        Action Required!
                    </div>
                    <div className={'expiration-popup-description'}>
                        It's been one (1) year since you last reviewed and<br/>updated your account information.
                        <br/><br/>
                        To ensure accuracy and to remain compliant with our<br/>
                        polices, please take a moment to review and update<br/>your profile.
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ExpirationPopupComponent;
